






















































































import { Inject } from '@cds/common';
import moment from 'moment';
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { NuoxiaoerService } from '@/services/nuoxiaoer-service';
import ArticleCatalogPopup from './ArticleCatalogPopup.vue';

@Component({
  components: {
    ArticleCatalogPopup,
  }
})
export default class ArticleCatalog extends Vue {
  public queryForm: Record<string, any> = {
    pages: 1,
    size: 10,
    current: 1,
    total: 0,
    appCoverName: '',
    createTimeRange: [],
  }
  public isShowPopup: Boolean = false; // 是否显示主目录popup
  public popupId: String = ''; // coverId uuid
  public tableData: any[] = [];
  public loading: Boolean = true;
  public coverOptions: any[] = []; // 封面选项

  @Inject(NuoxiaoerService) private nuoxiaoerService!: NuoxiaoerService;

  public async created(): Promise<void> {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      appCoverName: '',
      createTimeRange: [],
    }
    // 移除获取封面列表的调用，因为现在是输入框搜索
    await this.getList();
  }

  //查询接口
  public search() {
    this.queryForm.current = 1;
    this.getList()
  }

  //分页相关
  public handleSizeChange(size: number) {
    this.queryForm.size = size;
    this.getList();
  }

  public handleCurrentChange(current: number) {
    this.queryForm.current = current;
    this.getList();
  }

  //获取数据接口
  public async getList() {
    this.loading = true;
    let params: any = {
      createDateStart: (this.queryForm.createTimeRange || [])[0],
      createDateEnd: (this.queryForm.createTimeRange || [])[1],
      current: this.queryForm.current,
      size: this.queryForm.size,
      appCoverName: this.queryForm.appCoverName || undefined
    };

    try {
      const res = await this.nuoxiaoerService.fetchFolderList(params);
      console.log(res)
      this.loading = false;
      this.tableData = res.records || [];
      this.queryForm.total = res.total || 0;
      this.queryForm.pages = res.pages || 0;
      this.queryForm.size = res.size || 10;
      this.queryForm.current = res.current || 1;
    } catch (error) {
      this.loading = false;
      console.error('获取目录列表失败：', error);
      this.$message.error('获取列表数据失败，请稍后重试');
    }
  }

  // 格式化时间
  public formatTime(time: string): string {
    if (!time) return '';
    return moment(time).format('YYYY-MM-DD HH:mm:ss');
  }

  // 获取模块类型名称
  public getModelCodeName(code: string): string {
    switch(code) {
      case 'application':
        return '应用';
      case 'scenarios':
        return '业务场景';
      case 'novartis_video':
        return '诺华视界';
      default:
        return code || '';
    }
  }

  //删除接口
  private async handleDelete(row: any): Promise<void> {
    console.log('点击删除', row)

    if (row.folderCount > 0) {
      this.$message.warning('请确认无目录细项信息后方可执行删除');
      return;
    }

    try {
      await this.$confirm('请确认是否删除此目录？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      });

      const res = await this.nuoxiaoerService.deleteFolder({ id: row.id })
      console.log('res',res)
      if(res === 'ok'){
        console.log('res',res)
        this.getList();
        this.$message({
          message: '删除成功',
          type: 'success'
        });
      }
    } catch (e) {
      if (e === 'cancel') {
        this.$message({ type: 'info', message: '已取消删除' });
        return;
      }
      console.error('保存失败：', e);
      this.$message.error('保存失败：' + (e.message || '未知错误'));
    }
  }

  //重置
  public reset() {
    this.queryForm = {
      pages: 1,
      size: 10,
      current: 1,
      total: 0,
      appCoverName: '',
      createTimeRange: [],
    };
    this.getList()
  }

  /* 打开popup */
  public handleOpenPopup(rowData:any) {
    if (!rowData) {
      console.log('新增');
      // this.popupId = rowData.id;
      this.isShowPopup = true;
    } else {
      console.log('编辑 rowData:', rowData);
      this.popupId = rowData.appCoverId;
      this.isShowPopup = true;
    }
  }

  /* 保存后 */
  public handleAfterSaved() {
    console.log('handleAfterSaved');
    this.getList();
    this.isShowPopup = false;
    this.popupId = null;
  }

  /* 取消popup */
  public handleCancelPopup() {
    this.isShowPopup = false;
    this.popupId = null;
  }

   /* 关闭popup后 */
  public handleAfterClosePopup() {
    this.popupId = null;
  }

}
